import { render, staticRenderFns } from "./TenantCancellationRefundTiersEditor.vue?vue&type=template&id=20c5645d&scoped=true&"
import script from "./TenantCancellationRefundTiersEditor.vue?vue&type=script&lang=js&"
export * from "./TenantCancellationRefundTiersEditor.vue?vue&type=script&lang=js&"
import style0 from "./TenantCancellationRefundTiersEditor.vue?vue&type=style&index=0&id=20c5645d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5645d",
  null
  
)

export default component.exports